"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Branding = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = function styles(theme) {
  return {
    root: {
      display: "inline-flex",
      alignItems: "center"
    },
    logo: {}
  };
};
/**
 * Branding provides a simple component that displays
 * a logo (w/ optional title) and links to the provided link.
 * Typically used in site headers.
 */


var Branding = function Branding(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      component = _ref.component,
      link = _ref.link,
      logo = _ref.logo,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["classes", "className", "component", "link", "logo", "children"]);

  var Component = component;
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: (0, _clsx["default"])("HypBranding-root", classes.root, className),
    href: link
  }, props), logo && /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: (0, _clsx["default"])("HypBranding-logo", classes.logo)
  }, logo), children);
};

exports.Branding = Branding;
Branding.defaultProps = {
  classes: {},
  component: "a",
  link: "/"
};
Branding.propTypes = {
  /** Object that provides classnames to elements */
  classes: _propTypes["default"].object,

  /** class name for root element */
  className: _propTypes["default"].string,

  /** root component to use for this component */
  component: _propTypes["default"].any,

  /** URL to link the site branding to */
  link: _propTypes["default"].string,

  /** Logo image or component */
  logo: _propTypes["default"].node,
  children: _propTypes["default"].any
};
Branding.__docgenInfo = {
  "description": "Branding provides a simple component that displays\na logo (w/ optional title) and links to the provided link.\nTypically used in site headers.",
  "methods": [],
  "displayName": "Branding",
  "props": {
    "classes": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "Object that provides classnames to elements"
    },
    "component": {
      "defaultValue": {
        "value": "\"a\"",
        "computed": false
      },
      "type": {
        "name": "any"
      },
      "required": false,
      "description": "root component to use for this component"
    },
    "link": {
      "defaultValue": {
        "value": "\"/\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "URL to link the site branding to"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "class name for root element"
    },
    "logo": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Logo image or component"
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    }
  }
};
var exportComponent = (0, _core.withStyles)(styles, {
  name: "HypBranding"
})(Branding); // copy static props for storybook

if (process.env.NODE_ENV !== "production") {
  exportComponent.displayName = Branding.displayName;
  exportComponent.propTypes = Branding.propTypes;
  exportComponent.defaultProps = Branding.defaultProps;
}

var _default = exportComponent;
exports["default"] = _default;